import React, { useContext, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { Grid, IconButton, Menu, Popover } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/Add";
import makeStyles from "@mui/styles/makeStyles";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ConfirmationModal from "../ConfirmationModal";
import InformationModal from "../InformationModal";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
// import { v4 as uuidv4 } from "uuid";

import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import AcceptTicketWithoutQueue from "../AcceptTicketWithoutQueueModal";
import ForwardModal from "../ForwardMessageModal";
import ShowTicketOpen from "../ShowTicketOpenModal";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    padding: "4px", // Ajuste o valor conforme necessário
  },
  gridContainer: {
    padding: "10px",
    justifyContent: "center",
  },
  // addCircleButton: {
  //   padding: '8px',
  //   fontSize: '2rem', // Aumentar o tamanho do ícone
  //   backgroundColor: 'rgb(242 242 247);',
  // },
  popoverContent: {
    maxHeight: "300px", // Ajuste conforme necessário
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0.4em",
      height: "0.4em",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
      borderRadius: "50px",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
  },
  hideScrollbar: {
    maxHeight: "300px", // retirei porque estava quebrando a pagina
    overflow: "hidden",
  },
}));

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  isGroup,
  queueId,
  whatsappId,
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const editingContext = useContext(EditMessageContext);
  const setEditingMessage = editingContext
    ? editingContext.setEditingMessage
    : null;
  const { setTabOpen } = useContext(TicketsContext);
  const history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);

  const [ticketOpen, setTicketOpen] = useState(null);

  // Transcrição de áudio
  const [showTranscribedText, setShowTranscribedText] = useState(false);
  const [audioMessageTranscribeToText, setAudioMessageTranscribeToText] =
    useState("");

  // Reagir mensagens
  const [reactionAnchorEl, setReactionAnchorEl] = useState(null);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);

  const {
    showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    selectedMessages,
    forwardMessageModalOpen,
    setForwardMessageModalOpen,
    setSelectedMessages,
  } = useContext(ForwardMessageContext);

  const classes = useStyles();

  const handleCloseFowardMessageModal = () => {
    setForwardMessageModalOpen(false);
    setShowSelectMessageCheckbox(false);
    setSelectedMessages([]);
  };

  const openReactionsMenu = (event) => {
    setReactionAnchorEl(event.currentTarget);
    handleClose();
  };

  const closeReactionsMenu = () => {
    setReactionAnchorEl(null);
    handleClose();
  };

  const openMoreReactionsMenu = (event) => {
    setMoreAnchorEl(event.currentTarget);
    closeReactionsMenu(); // Fechar o primeiro popover
  };

  const closeMoreReactionsMenu = () => {
    setMoreAnchorEl(null);
  };

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;

    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        userId: user?.id,
        status: "open",
        queueId: queueId,
        whatsappId: whatsappId,
      });

      setTicketOpen(ticket);
      if (ticket.queueId === null) {
        setAcceptTicketWithouSelectQueueOpen(true);
      } else {
        setTabOpen("open");
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      try {
        const raw = err?.response?.data?.error;
        if (raw && typeof raw === 'string') {
          const ticket = JSON.parse(raw);
          if (ticket.userId !== user?.id) {
            setOpenAlert(true);
            setUserTicketOpen(ticket?.user?.name || "Outro atendente");
            setQueueTicketOpen(ticket?.queue?.name || "Fila");
          } else {
            setOpenAlert(false);
            setUserTicketOpen("");
            setQueueTicketOpen("");
            setTabOpen(ticket.status);
            if (ticket?.uuid) {
              history.push(`/tickets/${ticket.uuid}`);
            } else {
              history.push(`/tickets`);
            }
          }
        } else {
          toastError(err);
        }
      } catch (e) {
        toastError(err);
      }
    }
    //setLoading(false);
    handleClose();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSetShowSelectCheckbox = () => {
    setShowSelectMessageCheckbox(!showSelectMessageCheckbox);
    handleClose();
  };

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleEditMessage = async () => {
    setEditingMessage(message);
    handleClose();
  };
  // const handleForwardMessage = (msg) => {
  //   setForwardModalOpen(true);
  //   setForwardMessage(msg);
  //   handleClose();
  // };
  // const handleCloseForwardModal = () => {

  //   //setSelectedSchedule(null);
  //   setForwardModalOpen(false);
  //   handleClose();
  // };

  // Reagir Mensagens
  const handleReactToMessage = async (reactionType) => {
    try {
      await api.post(`/messages/${message.id}/reactions`, {
        type: reactionType,
      });
      toast.success(i18n.t("messageOptionsMenu.reactionSuccess"));
    } catch (err) {
      toastError(err);
    }
    closeReactionsMenu(); // Fechar o menu de reações ao reagir
  };

  // Array de emojis
  const availableReactions = [
    "😀",
    "😂",
    "❤️",
    "👍",
    "🎉",
    "😢",
    "😮",
    "😡",
    "👏",
    "🔥",
    "🥳",
    "😎",
    "🤩",
    "😜",
    "🤔",
    "🙄",
    "😴",
    "😇",
    "🤯",
    "💩",
    "🤗",
    "",
    "🤭",
    "🤓",
    "🤪",
    "🤥",
    "🤡",
    "🤠",
    "🤢",
    "🤧",
    "😷",
    "🤕",
    "🤒",
    "👻",
    "💀",
    "☠️",
    "👽",
    "👾",
    "🤖",
    "🎃",
    "😺",
    "",
    "😹",
    "😻",
    "😼",
    "😽",
    "🙀",
    "😿",
    "😾",
    "🙈",
    "🙉",
    "",
    "🐵",
    "🐒",
    "🦍",
    "🐶",
    "🐕",
    "🐩",
    "🐺",
    "🦊",
    "🦝",
    "🐱",
    "🐈",
    "🦁",
    "🐯",
    "🐅",
    "🐆",
    "🐴",
    "🐎",
    "🦄",
  ];

  const handleTranscriptionAudioToText = async () => {
    try {
      const audioUrl = String(message.mediaUrl);

      const match = audioUrl.match(/\/([^\/]+\.ogg)$/);
      const extractedPart = match ? match[1] : null;

      if (!extractedPart) {
        throw new Error("Formato de URL de áudio inesperado");
      }

      const response = await api.get(
        `/messages/transcribeAudio/${extractedPart}`
      );
      const { data } = response;

      if (data && typeof data.transcribedText === "string") {
        setAudioMessageTranscribeToText(data.transcribedText);
        setShowTranscribedText(true);
        handleClose();
      } else if (data && data.error) {
        throw new Error(data.error);
      } else {
        throw new Error("Dados de transcrição inválidos");
      }
    } catch (err) {
      toastError(err);
    } finally {
      setReactionAnchorEl(null);
      handleClose();
    }
  };

  // Baixar áudio da mensagem
  const handleDownloadAudio = async () => {
    try {
      const url = String(message?.mediaUrl || "");
      if (!url) {
        toast.error("URL de áudio indisponível");
        return;
      }

      // Normaliza a URL para absoluto e evita mixed content
      const normalizeMediaUrl = (u) => {
        let out = u;
        try {
          if (out.includes("localhost:443/")) {
            out = out.replace("localhost:443/", "localhost:8080/");
          }
          const loc = window.location;
          const isHttpsPage = loc.protocol === "https:";
          const urlObj = new URL(out, loc.origin);
          if (out.startsWith("/public/")) {
            urlObj.protocol = loc.protocol;
            urlObj.host = loc.host;
          }
          if (isHttpsPage && urlObj.protocol === "http:") {
            urlObj.protocol = "https:";
          }
          return urlObj.toString();
        } catch {
          return out;
        }
      };

      const href = normalizeMediaUrl(url);

      // Busca como Blob para forçar o download (mesmo quando o servidor não envia attachment)
      let blob;
      try {
        const res = await fetch(href, { credentials: 'include' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        blob = await res.blob();
      } catch (e) {
        // Se falhar (ex.: CORS), faz fallback para o href direto
        const a = document.createElement("a");
        a.href = href;
        a.setAttribute("download", message?.filename || message?.originalName || `audio-${message?.id || "mensagem"}`);
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      }

      // Define nome de arquivo com extensão adequada
      const guessedFromUrl = (() => {
        try {
          const u = new URL(href);
          const pathname = u.pathname || "";
          const base = pathname.split("/").pop() || "";
          return base || null;
        } catch { return null; }
      })();
      const mime = (blob && blob.type) || '';
      const extFromMime = mime.includes('ogg') ? '.ogg' : (mime.includes('mpeg') ? '.mp3' : (mime.includes('mp4') ? '.m4a' : ''));
      let baseName = message?.filename || message?.originalName || guessedFromUrl || `audio-${message?.id || "mensagem"}`;
      if (extFromMime && !/\.[a-z0-9]{2,5}$/i.test(baseName)) {
        baseName += extFromMime;
      }

      // Cria URL local e dispara o download
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.setAttribute("download", baseName);
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
    } catch (e) {
      console.error("Falha ao baixar áudio:", e);
      toastError(e);
    } finally {
      handleClose();
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const isWithinFifteenMinutes = () => {
    const fifteenMinutesInMilliseconds = 15 * 60 * 1000; // 15 minutos em milissegundos
    const currentTime = new Date();
    const messageTime = new Date(message.createdAt);

    // Verifica se a diferença entre o tempo atual e o tempo da mensagem é menor que 15 minutos
    return currentTime - messageTime <= fifteenMinutesInMilliseconds;
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  return (
    <>
      <AcceptTicketWithoutQueue
        modalOpen={acceptTicketWithouSelectQueueOpen}
        onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
        ticket={ticketOpen}
        ticketId={ticketOpen?.id}
      />
      <ShowTicketOpen
        isOpen={openAlert}
        handleClose={handleCloseAlert}
        user={userTicketOpen}
        queue={queueTicketOpen}
      />
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>

      <InformationModal
        title={i18n.t("Transcrição de áudio")}
        open={showTranscribedText}
        onClose={setShowTranscribedText}
      >
        {audioMessageTranscribeToText}
      </InformationModal>

      <ForwardModal
        modalOpen={forwardMessageModalOpen}
        messages={selectedMessages}
        onClose={handleCloseFowardMessageModal}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && (
          <MenuItem key="delete" onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {message.fromMe && isWithinFifteenMinutes() && (
          <MenuItem key="edit" onClick={handleEditMessage}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        {message.mediaType === "audio" && !message.fromMe && (
          <MenuItem onClick={handleTranscriptionAudioToText}>
            {i18n.t("Transcrever áudio")}
          </MenuItem>
        )}
        {message.mediaType === "audio" && (
          <MenuItem onClick={handleDownloadAudio}>
            {i18n.t("Baixar áudio")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        <MenuItem onClick={handleSetShowSelectCheckbox}>
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
        {/* {!isGroup && ( */}
          <MenuItem onClick={openReactionsMenu}>
            {i18n.t("messageOptionsMenu.react")}
          </MenuItem>
        {/* )} */}

        {!message.fromMe && isGroup && (
          <MenuItem onClick={() => handleSaveTicket(message?.contact?.id)}>
            {i18n.t("messageOptionsMenu.talkTo")}
          </MenuItem>
        )}
      </Menu>
      <Popover
        open={Boolean(reactionAnchorEl)}
        anchorEl={reactionAnchorEl}
        onClose={closeReactionsMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: { width: "auto", maxWidth: "380px", borderRadius: "50px" },
        }}
      >
        <div className={classes.hideScrollbar}>
          <Grid container spacing={1} className={classes.gridContainer}>
            {availableReactions.slice(0, 6).map((reaction) => (
              <Grid item key={reaction}>
                <IconButton
                  className={classes.iconButton}
                  onClick={() => handleReactToMessage(reaction)}
                  size="large"
                >
                  {reaction}
                </IconButton>
              </Grid>
            ))}
            <Grid item>
              <IconButton
                // className={classes.addCircleButton}
                onClick={openMoreReactionsMenu}
                size="large"
              >
                <AddCircleOutlineIcon fontSize="normal" />
              </IconButton>
            </Grid>
          </Grid>
        </div>
      </Popover>
      <Popover
        open={Boolean(moreAnchorEl)}
        anchorEl={moreAnchorEl}
        onClose={closeMoreReactionsMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          style: { width: "auto", maxWidth: "400px", borderRadius: "6px" },
        }}
      >
        <div className={classes.popoverContent}>
          <Grid container spacing={1} className={classes.gridContainer}>
            {availableReactions.map((reaction) => (
              <Grid item key={reaction}>
                <IconButton
                  className={classes.iconButton}
                  onClick={() => handleReactToMessage(reaction)}
                  size="large"
                >
                  {reaction}
                </IconButton>
              </Grid>
            ))}
          </Grid>
        </div>
      </Popover>
    </>
  );
};

export default MessageOptionsMenu;
